import { useToast } from '../contexts/toast-context';

/**
 * Hook that provides convenient methods for showing global notifications
 * with automatic error handling and loading states
 */
export const useGlobalNotifications = () => {
  const { showLoading, showError, showSuccess, hideNotification } = useToast();

  const withLoading = async <T>(
    asyncFn: () => Promise<T>,
    loadingMessage = 'Preparing your data',
    successMessage?: string
  ): Promise<T> => {
    try {
      showLoading(loadingMessage);
      const result = await asyncFn();
      hideNotification();
      if (successMessage) {
        showSuccess(successMessage); // Uses default 3-second timeout
      }
      return result;
    } catch (error) {
      hideNotification();
      const message = error instanceof Error ? error.message : 'An error occurred';
      showError(message); // Uses default 3-second timeout
      throw error;
    }
  };

  return {
    showLoading,
    showError,
    showSuccess,
    hideNotification,
    withLoading,
  };
};